<template>
  <label class="inline-flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap text-[10px] uppercase tracking-[0.18em]" :class="simulation ? 'text-[#d6336c]' : 'text-[#5c574f]'">
    <span>Mode simulation</span>
    <button
      type="button"
      role="switch"
      :aria-checked="simulation"
      aria-label="Mode simulation"
      class="relative h-5 w-9 shrink-0 rounded-full transition"
      :class="simulation ? 'bg-[#d6336c]' : 'bg-[#d9d2c5]'"
      @click="emit('update:modelValue', simulation ? 'real' : 'simulation')"
    >
      <span class="absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white shadow transition-transform" :class="simulation ? 'translate-x-4' : ''" />
    </button>
  </label>
</template>

<script setup lang="ts">
import type { StockMode } from '~/utils/stockModels'

const props = defineProps<{ modelValue: StockMode }>()
const emit = defineEmits<{ 'update:modelValue': [value: StockMode] }>()
const simulation = computed(() => props.modelValue === 'simulation')
</script>
